var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        switchFullscreen: "",
        cancelText: "关闭",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _vm.visible
        ? _c(
            "video",
            {
              ref: "myVideo",
              staticClass: "video-js vjs-default-skin",
              staticStyle: { height: "100%", width: "100%" },
              attrs: {
                controls: "",
                preload: "auto",
                width: "640",
                height: "360",
                autoplay: "",
              },
            },
            [
              _c("source", {
                attrs: {
                  src:
                    _vm.window._CONFIG["resourceURL"] +
                    "/school/sys/common/static" +
                    _vm.videoPlay,
                  type: "video/mp4",
                },
              }),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }